module.exports = __webpack_public_path__ + "img/3-zh.89657db7.png";